import DeviceDetection from '@/ports-frontend/DeviceDetection';

const LivePersonChat = {
  invoke: {
    async activateEngagement([name, redirectUrl, iosRedirectUrl]: [
      string,
      string,
      string
    ]) {
      try {
        await window.parent.WH.bootstrapper.features[
          'live-chat-flow'
        ].activateEngagement({
          name,
        });
      } catch (e) {
        const {
          isNative,
          deviceOs,
          nativeDeviceOs,
        } = await DeviceDetection.getDeviceInfo();
        const isNativeIOS =
          (isNative && deviceOs === 'ios') || nativeDeviceOs === 'ios';
        window.open(isNativeIOS ? iosRedirectUrl : redirectUrl);
      }
    },
  },
  on: {
    onOpenCashierLiveChat(callback: Function) {
      const listener = (event: MessageEvent) => {
        const message = event.data;
        if (message === 'openCashierLiveChat') {
          callback();
        }
      };
      window.addEventListener('message', listener);
      return () => {
        window.removeEventListener('message', listener);
      };
    },
  },
};

export default LivePersonChat;
